/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Archived_ToastInputs */

const en_lifecycle_archived_toast = /** @type {(inputs: Lifecycle_Archived_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} archived`)
};

const de_lifecycle_archived_toast = /** @type {(inputs: Lifecycle_Archived_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} archiviert`)
};

/**
* | output |
* | --- |
* | "{name} archived" |
*
* @param {Lifecycle_Archived_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archived_toast = /** @type {((inputs: Lifecycle_Archived_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archived_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archived_toast(inputs)
	return en_lifecycle_archived_toast(inputs)
});